import { render, staticRenderFns } from "./WidgetView.vue?vue&type=template&id=59c1943c&scoped=true"
import script from "./WidgetView.vue?vue&type=script&lang=js"
export * from "./WidgetView.vue?vue&type=script&lang=js"
import style0 from "./WidgetView.vue?vue&type=style&index=0&id=59c1943c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1943c",
  null
  
)

export default component.exports